var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_338_19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z",
    fill: "#009BE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.875 12L12.875 16",
    stroke: "white",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 15L12.875 17L14.75 15",
    stroke: "white",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 8C15 6.34315 13.433 5 11.5 5C9.567 5 8 6.34315 8 8",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 13C16.2091 13 18 11.9668 18 10.6923C18 9.4178 16.7091 8 14.5 8",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8C6.29086 8 5 9.0572 5 10.46C5 11.8628 6.79086 13 9 13H11.5",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_338_19"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon_download.918a6e3fae15bf03caebf5e079ce62a6.svg";
export { ForwardRef as ReactComponent };